import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import React, {ChangeEvent, Component, ReactElement, ReactNode} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import ListSearchFormArea from '../../../styledComponents/adminPage/ListSearchFormArea'
import {SearchResultCountDisplayProps} from '../../../styledComponents/adminPage/SearchResultCountDisplay'
import {DisasterModeInfo, SearchCondition, SearchResult} from './repository/NatSearchDisasterModeStatusList'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent'
import SearchPageActionArea from '../../../styledComponents/adminPage/SearchPageActionArea'
import {PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import styled from 'styled-components'
import {CondominiumGroupData, NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import {FlexGridArea} from '../../../styledComponents/GridComponents'
import HintButton from '../../../components/shared/pageBaseComponents/HintButton'
import {Messages} from '../../../Messages'
import {AdminDefaultButton, AdminDefaultMediumButton} from '../../../styledComponents/adminPage/Buttons'
import {NewEllipsisText} from '../../../components/assocDirector/AssocDirectorCommon'
import {
    AssocStatusCondominiumInfo,
    isAssocStatusCondominiumInfoList
} from '../../../components/assocDirector/model/AssocStatus'
import {CookieHelper} from '../../../CookieHelper'
import {
    AdminLoginInfoSessionStorageKey,
    NatAdminLoginInfoSessionStorageHelper
} from '../../common/authentication/NatAdminLoginInfoSessionStorageHelper'
import {CondominiumInfo} from '../condominium/repository/NatGetCondominiumList'
import NatCondominiumSelectionComponent from '../common/admin/NatCondominiumSelectionComponent'
import {
    DISASTER_MODE,
    HAVE_OR_NOT,
    PREFECTURES_MASTER,
    REGISTER_TYPE,
    SELECT_CONDOMINIUM_TYPE, USE_FUNCTION_ID
} from '../../../CodeMaster'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import PPInput from '../../../components/shared/forms/PPInput'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {HKConstants} from '../../../HKConstants'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import SortablePaginationTable from '../../../styledComponents/adminPage/SortablePaginationTable'
import SortablePaginationTableBody from '../../../styledComponents/adminPage/SortablePaginationTableBody'
import {Box, Link, TableCell, TableRow, SortDirection} from '@mui/material'
import HoverPopupArea from '../../../components/shared/HoverPopupArea'
import {SortOrder} from '../../../components/shared/SortOrder'
import {Colors, FontSizeInPixel, FontWeights} from '../../../styledComponents/Constants'
import NatDisasterRepo from './repository/NatDisasterRepo'
import PPCheckboxGroup from '../../../components/shared/forms/PPCheckboxGroup'
import {
    formatDateSlashSeparator,
    formatDateTimeForUpdateDate,
    formatDateTimeSlashSeparator
} from '../../../formatters/formatDate'
import PPMultiSelect from '../../../components/shared/forms/PPMultiSelect'
import {getPrefectureName} from '../../common/util/Natutil'
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined'
import PPTextField from '../../../components/shared/forms/PPTextField'
import SortableTableHeader, {SortableTableHeaderCell} from '../../../styledComponents/adminPage/SortablePaginationTableHeader'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {CenterRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Location} from 'react-router-dom'

const KEY_DISASTER_MODE_STATUS_LIST_SEARCH_CONDITION: string = 'disasterModeStatusListSearchCondition'
const COOKIE_KEY_BASE_ASSOC_STATUS_CONDOMINIUM_INFO: string = 'adminAssocStatusListPage-SelectedCondominiumInfo'

interface Props {
    condominiumGroupRepo: NatCondominiumGroupRepo
    condominiumRepo: NatCondominiumRepo
    disasterRepo: NatDisasterRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    condominiumGroup: Nullable<CondominiumGroupData>
    selectedCondominiumGroupId: number
    selectedCondominiumInfoList: AssocStatusCondominiumInfo[]
    noResultMessage: string
    disasterModeStatusList: DisasterModeInfo[]
    searchResult: SearchResult
    searchCondition: SearchCondition
    searchConditionSortInfo: SortOrder[]
    isOpenSelectCondominiumDialog: boolean
    isLoadCompleted: boolean
}
class NatAdminDisasterModeStatusListPage extends Component<Props & AdminPagePropsSet, States> {
    cookieKey: string
    subSortKey: SortOrder = new SortOrder('condominiumCd', 'asc')
    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        // 検索条件の初期設定
        let defaultSearchCondition: SearchCondition = {}
        let lastSearchCondition: SearchCondition = {}
        // 前回検索条件が保持されていればデフォルト値として設定する
        const sessionStorageSearchCondition: Nullable<string> =
            SessionStorageHelper.getStringItemOrNull(KEY_DISASTER_MODE_STATUS_LIST_SEARCH_CONDITION)
        if (sessionStorageSearchCondition) {
            lastSearchCondition = JSON.parse(sessionStorageSearchCondition)
        } else {
            defaultSearchCondition.condominiumGroupId = 1
            // 前回検索条件が保持されていない場合、災害時モードと防災情報をチェック済みにする
            const defaultDisasterModeCheck: string[] = []
            defaultDisasterModeCheck.push(DISASTER_MODE.ON.value)
            defaultDisasterModeCheck.push(DISASTER_MODE.OFF.value)
            defaultSearchCondition.disasterMode = defaultDisasterModeCheck.join(',')
            const defaultDisasterPreventionCheck: string[] = []
            defaultDisasterPreventionCheck.push(REGISTER_TYPE.REGISTED.value)
            defaultDisasterPreventionCheck.push(REGISTER_TYPE.UNREGISTERD.value)
            defaultSearchCondition.disasterPrevention = defaultDisasterPreventionCheck.join(',')
        }
        if (lastSearchCondition.pageNum) {
            lastSearchCondition.pageNum = Number(lastSearchCondition.pageNum)
            lastSearchCondition.page = COMMON_CONSTANTS.FIRST_PAGE
        } else {
            defaultSearchCondition.pageNum = COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[2]
            defaultSearchCondition.page = COMMON_CONSTANTS.FIRST_PAGE
        }
        if (Object.keys(lastSearchCondition).length) {
            defaultSearchCondition = {...lastSearchCondition}
        }

        const loginUserAdminId = NatAdminLoginInfoSessionStorageHelper
            .getStringItemOrNull(AdminLoginInfoSessionStorageKey.LOGIN_USER_ADMIN_ID)
        const loginUserCondominiumGroupId = NatAdminLoginInfoSessionStorageHelper
            .getNumberItemOrNull(AdminLoginInfoSessionStorageKey.LOGIN_USER_CONDOMINIUM_GROUP_ID)
        if (loginUserAdminId === null || loginUserCondominiumGroupId === null) {
            throw Error('ログインユーザの管理者ID、所属物件グループが取得できなかった。')
        }
        this.cookieKey = `${COOKIE_KEY_BASE_ASSOC_STATUS_CONDOMINIUM_INFO}-${loginUserAdminId}-${loginUserCondominiumGroupId}`
        const condominiumInfoList = this.loadCondominiumInfoListFromCookie()
        defaultSearchCondition.condominiumCdList = condominiumInfoList
            .map(condominiumInfo => condominiumInfo.condominiumCd).join(',')
        this.state = {
            condominiumGroup: null,
            selectedCondominiumGroupId: loginUserCondominiumGroupId,
            selectedCondominiumInfoList: condominiumInfoList,
            noResultMessage: '',
            disasterModeStatusList: [],
            searchResult: {},
            searchCondition: defaultSearchCondition,
            searchConditionSortInfo: [
                new SortOrder('disasterMode', 'desc'), new SortOrder('latestCommentDatetime', 'desc'),
            ],
            isOpenSelectCondominiumDialog: false,
            isLoadCompleted: false
        }
        this.handleSelectCondominiumButtonClick = this.handleSelectCondominiumButtonClick.bind(this)
        this.closeSelectCondominiumDialog = this.closeSelectCondominiumDialog.bind(this)
        this.setSelectedCondominiumInfoList = this.setSelectedCondominiumInfoList.bind(this)
        this.onChangeCondominiumGroupId = this.onChangeCondominiumGroupId.bind(this)
        this.onChangeCondominiumCd = this.onChangeCondominiumCd.bind(this)
        this.onChangeCondominiumName = this.onChangeCondominiumName.bind(this)
        this.onChangePrefecture = this.onChangePrefecture.bind(this)
        this.onChangeAddress2 = this.onChangeAddress2.bind(this)
        this.onChangeDisasterModeListChecked = this.onChangeDisasterModeListChecked.bind(this)
        this.onChangeDisasterPreventionListChecked = this.onChangeDisasterPreventionListChecked.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.handleSortApplication = this.handleSortApplication.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.onClickSettingButton = this.onClickSettingButton.bind(this)
        this.onClickReleaseButton = this.onClickReleaseButton.bind(this)
        this.onClickDisasterModeStatusDataOutput = this.onClickDisasterModeStatusDataOutput.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        this.showInitialMessage()
        try {
            const condominiumGroupResponse = await this.getCondominiumGroup()

            this.setState({
                condominiumGroup: condominiumGroupResponse
            })
            await this.getDisasterModeStatusList(
                this.state.searchCondition,
                this.state.searchConditionSortInfo,
            )
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true, state: {}})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    loadCondominiumInfoListFromCookie(): AssocStatusCondominiumInfo[] {
        const cookieCondominiumInfoListJson = CookieHelper.getStringValue(this.cookieKey)
        let condominiumInfoList: AssocStatusCondominiumInfo[] = []

        if (cookieCondominiumInfoListJson) {
            try {
                const cookieCondominiumInfoList = JSON.parse(cookieCondominiumInfoListJson) as unknown
                if (isAssocStatusCondominiumInfoList(cookieCondominiumInfoList)) {
                    condominiumInfoList = cookieCondominiumInfoList
                        .map(condominiumInfo => ({
                            condominiumCd: condominiumInfo.condominiumCd
                        }))
                }
            } catch (e) {
                // オブジェクト変換時のエラーは無視する
            }
        }
        return condominiumInfoList
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    async getCondominiumGroup(): Promise<Nullable<CondominiumGroupData>> {
        const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
            this.props.condominiumGroupRepo.getCondominiumGroup.bind(
                this.props.condominiumGroupRepo,
                [HKConstants.VMN.COG.HASEKO_HOLDINGS_CONDOMINIUM_GROUP_ID]
            ),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return condominiumGroupResponse?.details ?? null
    }

    onChangeCondominiumGroupId(condominiumGroupId: number): void {
        const searchConditions = this.state.searchCondition
        searchConditions.condominiumGroupId = condominiumGroupId
        this.setState({searchCondition: searchConditions})
    }

    closeSelectCondominiumDialog(): void {
        this.setState({
            isOpenSelectCondominiumDialog: false,
        })
    }

    handleSelectCondominiumButtonClick(): void {
        this.setState({
            isOpenSelectCondominiumDialog: true,
        })
    }

    setSelectedCondominiumInfoList(selectedCondominiumInfoList: CondominiumInfo[]): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.condominiumCdList = selectedCondominiumInfoList
            .map(infoList => infoList.condominiumCd).join(',')
        this.setState({
            isOpenSelectCondominiumDialog: false,
            searchCondition: searchCondition,
            selectedCondominiumInfoList: selectedCondominiumInfoList.map(selectedCondominiumInfo => ({
                condominiumCd: selectedCondominiumInfo.condominiumCd
            })),
        })
    }

    onChangeCondominiumCd(event: ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition;
        searchConditions.condominiumCd = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    onChangeCondominiumName(event: ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition;
        searchConditions.condominiumName = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    onChangePrefecture(values: string[]): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.prefectureCd = values.join(',')
        this.setState({searchCondition: searchCondition})
    }

    onChangeAddress2(event: ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition;
        searchConditions.address2 = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    onChangeDisasterModeListChecked(label: string): void {
        const checkedValue: string[] = (this.state.searchCondition.disasterMode) ?
            this.state.searchCondition.disasterMode.split(',') : [];

        const checkStatus = DISASTER_MODE.values().filter(disasterMode => {
            return disasterMode.label === label
        })[0].value;

        if (checkedValue.includes(checkStatus)) {
            checkedValue.splice(checkedValue.indexOf(checkStatus), 1)
        } else {
            checkedValue.push(checkStatus)
        }
        const searchCondition = this.state.searchCondition;
        searchCondition.disasterMode = checkedValue.join(',');
        this.setState({searchCondition: searchCondition})
    }

    onChangeDisasterPreventionListChecked(label: string): void {
        const checkedValue: string[] = (this.state.searchCondition.disasterPrevention) ?
            this.state.searchCondition.disasterPrevention.split(',') : [];

        const checkStatus = REGISTER_TYPE.values().filter(disasterPrevention => {
            return disasterPrevention.label === label
        })[0].value;

        if (checkedValue.includes(checkStatus)) {
            checkedValue.splice(checkedValue.indexOf(checkStatus), 1)
        } else {
            checkedValue.push(checkStatus)
        }
        const searchCondition = this.state.searchCondition;
        searchCondition.disasterPrevention = checkedValue.join(',');
        this.setState({searchCondition: searchCondition})
    }

    async onClickSearchButton(): Promise<void> {
        this.beforeUserAction()
        const {selectedCondominiumInfoList} = this.state
        // 検索条件を保持
        const lastSearchCondition: SearchCondition = {
            condominiumGroupId: this.state.searchCondition.condominiumGroupId,
            condominiumCdList: this.state.searchCondition.condominiumCdList,
            condominiumCd: this.state.searchCondition.condominiumCd,
            condominiumName: this.state.searchCondition.condominiumName,
            prefectureCd: this.state.searchCondition.prefectureCd,
            address2: this.state.searchCondition.address2,
            disasterMode: this.state.searchCondition.disasterMode,
            disasterPrevention: this.state.searchCondition.disasterPrevention,
            pageNum: this.state.searchCondition.pageNum,
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        SessionStorageHelper.setItem(
            KEY_DISASTER_MODE_STATUS_LIST_SEARCH_CONDITION,
            JSON.stringify(lastSearchCondition)
        )
        CookieHelper.setStringValue(
            this.cookieKey,
            JSON.stringify(selectedCondominiumInfoList),
        )
        await this.getDisasterModeStatusList(
            lastSearchCondition,
            this.state.searchConditionSortInfo,
        )
    }

    async getDisasterModeStatusList(
        searchCondition: SearchCondition,
        searchConditionSortInfo: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {
            const disasterModeStatusListResponse = await this.props.asyncCallFunction(
                this.props.disasterRepo.searchDisasterModeStatusList.bind(
                    this.props.disasterRepo,
                    searchCondition, [...searchConditionSortInfo, this.subSortKey]),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

            if (disasterModeStatusListResponse?.details) {
                let noResultMessage: string = ''
                if (disasterModeStatusListResponse.details.searchResult.total === 0) {
                    noResultMessage = Messages.IOPCC0014.toString()
                }

                this.setState({
                    noResultMessage: noResultMessage,
                    disasterModeStatusList: disasterModeStatusListResponse.details.disasterModeInfo,
                    searchResult: disasterModeStatusListResponse.details.searchResult,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    searchResults(): SearchResultCountDisplayProps {
        if (this.state.disasterModeStatusList.length === 0) {
            return {noResultMessage: this.state.noResultMessage}
        }

        return {
            totalCount: this.state.searchResult.total ? this.state.searchResult.total : undefined,
            rowsPerPage: this.state.searchCondition.pageNum,
            page: this.state.searchCondition.page,
        }
    }

    async onClickSettingButton(): Promise<void> {
        this.props.navigate('/admin/disasters/mode/setting')
    }

    async onClickReleaseButton(): Promise<void> {
        this.props.navigate('/admin/disasters/mode/release')
    }

    async onClickDisasterModeStatusDataOutput(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const searchCondition: SearchCondition = {
                condominiumGroupId: this.state.searchCondition.condominiumGroupId,
                condominiumCdList: this.state.searchCondition.condominiumCdList,
                condominiumCd: this.state.searchCondition.condominiumCd,
                condominiumName: this.state.searchCondition.condominiumName,
                prefectureCd: this.state.searchCondition.prefectureCd,
                address2: this.state.searchCondition.address2,
                disasterMode: this.state.searchCondition.disasterMode,
                disasterPrevention: this.state.searchCondition.disasterPrevention,
            }
            const tempLink: HTMLAnchorElement = document.createElement('a')
            tempLink.href = NatDisasterRepo.exportDisasterModeStatusListByCsvData(searchCondition)
            document.body.appendChild(tempLink)
            tempLink.click()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.page = newPage
        await this.getDisasterModeStatusList(
            this.state.searchCondition,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchCondition: searchCondition})
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()

        // 検索条件を保持
        const lastSearchCondition: SearchCondition = {
            condominiumGroupId: this.state.searchCondition.condominiumGroupId,
            condominiumCdList: this.state.searchCondition.condominiumCdList,
            condominiumCd: this.state.searchCondition.condominiumCd,
            condominiumName: this.state.searchCondition.condominiumName,
            prefectureCd: this.state.searchCondition.prefectureCd,
            address2: this.state.searchCondition.address2,
            disasterMode: this.state.searchCondition.disasterMode,
            disasterPrevention: this.state.searchCondition.disasterPrevention,
            page: COMMON_CONSTANTS.FIRST_PAGE,
            pageNum: Number(event.target.value),

        }
        SessionStorageHelper.setItem(KEY_DISASTER_MODE_STATUS_LIST_SEARCH_CONDITION,
            JSON.stringify(lastSearchCondition))

        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.pageNum = Number(event.target.value)
        searchCondition.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.getDisasterModeStatusList(
            this.state.searchCondition,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchCondition: searchCondition})
    }

    async handleSortApplication(sortKey: string): Promise<void> {
        this.beforeUserAction()

        let sortDirection: SortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        const sortOrders: SortOrder[] = [new SortOrder(sortKey, sortDirection)]
        await this.getDisasterModeStatusList(
            this.state.searchCondition,
            sortOrders,
        )
        this.setState({searchConditionSortInfo: sortOrders})
    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.searchConditionSortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }

    judgeCheckDisasterModeStatus(disasterMode: string): boolean {
        if (!this.state.searchCondition || !this.state.searchCondition.disasterMode) {
            return false
        }
        const roleArray: string[] = this.state.searchCondition.disasterMode.split(',')
        return roleArray.indexOf(disasterMode) >= 0
    }

    judgeCheckDisasterPreventionStatus(disasterPrevention: string): boolean {
        if (!this.state.searchCondition || !this.state.searchCondition.disasterPrevention) {
            return false
        }
        const roleArray: string[] = this.state.searchCondition.disasterPrevention.split(',')
        return roleArray.indexOf(disasterPrevention) >= 0
    }
    renderDisasterModeStatusSearchInfo(): ReactNode {
        const {
            selectedCondominiumGroupId,
            selectedCondominiumInfoList,
            isOpenSelectCondominiumDialog,
        } = this.state
        const prefectures = PREFECTURES_MASTER.values().map(prefecture => {
            return {value: prefecture.value, label: prefecture.label}
        })
        const disasterModeCheckBoxData = DISASTER_MODE.values().map(
            disasterModeStatus => ({
                label: disasterModeStatus.label,
                checked: this.judgeCheckDisasterModeStatus(disasterModeStatus.value),
            }))
        const disasterPreventionCheckBoxData = REGISTER_TYPE.values().map(
            disasterPreventionStatus => ({
                label: disasterPreventionStatus.label,
                checked: this.judgeCheckDisasterPreventionStatus(disasterPreventionStatus.value),
            }))
        const selectedCondominiumCdList: CondominiumInfo[] = selectedCondominiumInfoList.map(selectedCondominium => {
            return {
                condominiumCd: selectedCondominium.condominiumCd,
                condominiumName: '',
                condominiumGroupName: '',
                prefectureCd: '',
                address2: '',
                updateDatetime: '',
                releaseFlg: ''
            }
        })
        return (
            <>
                <ListSearchFormArea
                    searchResult={this.searchResults()}
                    onEnterKey={this.onClickSearchButton}>
                    <Box height={'8px'}/>
                    <SearchForm>
                        <NonGridDiv className={'condominiumGroupRow'}>
                            <FlexGridArea area={'condominiumGroupSelectLabel'}>
                                <SearchFormText>
                                    物件グループを選択
                                </SearchFormText>
                            </FlexGridArea>
                            <FlexGridArea area={'condominiumGroupSelect'}>
                                <SearchFormInputContainer>
                                    {this.state.condominiumGroup &&
                                        <NatCondominiumGroupSelectComponent
                                            condominiumGroup={this.state.condominiumGroup}
                                            defaultValue={(this.state.searchCondition.condominiumGroupId) ?
                                                this.state.searchCondition.condominiumGroupId : null}
                                            onChangeSelectedCondominiumGroupId={this.onChangeCondominiumGroupId}
                                            requiredFlag={true}
                                        />
                                    }
                                </SearchFormInputContainer>
                            </FlexGridArea>
                        </NonGridDiv>
                        <NonGridDiv className={'condominiumSelectRow'}>
                            <FlexGridArea area={'condominiumSelectLabel'}>
                                <SearchFormText>
                                    物件リストから選択
                                </SearchFormText>
                                <HintButton message={Messages.HASOA0002.message}/>
                            </FlexGridArea>
                            <FlexGridArea area={'condominiumSelectButton'}>
                                <AdminDefaultButton onClick={this.handleSelectCondominiumButtonClick}>
                                    物件を選択する
                                </AdminDefaultButton>
                            </FlexGridArea>
                            <FlexGridArea area={'selectedCondominiums'}>
                                <NewEllipsisText lineHeightInPixel={21} numOfLines={2}>
                                    {selectedCondominiumInfoList
                                        .map(selectedCondominiumInfo => selectedCondominiumInfo.condominiumCd)
                                        .join('，')}
                                </NewEllipsisText>
                            </FlexGridArea>
                        </NonGridDiv>
                        <NonGridDiv className={'CondominiumCdAndCondominiumNameRow'}>
                            <FlexGridArea area={'CondominiumCdLabel'}>
                                <SearchFormText>
                                    物件コード
                                </SearchFormText>
                            </FlexGridArea>
                            <FlexGridArea area={'CondominiumCd'}>
                                <SearchInputContainerLeft>
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                maxLength: 6,
                                            },
                                        }}
                                        fullWidth
                                        onChange={this.onChangeCondominiumCd}
                                        defaultValue={this.state.searchCondition.condominiumCd}
                                    />
                                </SearchInputContainerLeft>
                            </FlexGridArea>
                            <FlexGridArea area={'CondominiumNameLabel'}>
                                <SearchFormText>
                                    物件名
                                </SearchFormText>
                            </FlexGridArea>
                            <FlexGridArea area={'CondominiumName'}>
                                <SearchInputContainerRight>
                                    <PPInput
                                        onChange={this.onChangeCondominiumName}
                                        inputProps={{
                                            minLength: 0,
                                            maxLength: 50,
                                        }}
                                        fullWidth
                                        defaultValue={this.state.searchCondition.condominiumName}
                                    />
                                </SearchInputContainerRight>
                            </FlexGridArea>
                        </NonGridDiv>
                        <NonGridDiv className={'prefectureCdAndAddress2Row'}>
                            <FlexGridArea area={'prefectureCdLabel'}>
                                <SearchFormText>
                                    都道府県
                                </SearchFormText>
                            </FlexGridArea>
                            <FlexGridArea area={'prefectureCd'}>
                                <SearchInputContainerLeft>
                                    <PPMultiSelect
                                        options={prefectures}
                                        placeholder={'都道府県を選択してください（複数可）'}
                                        onChange={this.onChangePrefecture}
                                        defaultValue={this.state.searchCondition.prefectureCd?.split(',')}
                                    />
                                </SearchInputContainerLeft>
                            </FlexGridArea>
                            <FlexGridArea area={'address2Label'}>
                                <SearchFormText>
                                    市区町村
                                </SearchFormText>
                            </FlexGridArea>
                            <FlexGridArea area={'address2'}>
                                <SearchInputContainerRight>
                                    <PPInput
                                        onChange={this.onChangeAddress2}
                                        inputProps={{
                                            minLength: 0,
                                            maxLength: 50,
                                        }}
                                        fullWidth
                                        defaultValue={this.state.searchCondition.address2}
                                    />
                                </SearchInputContainerRight>
                            </FlexGridArea>
                        </NonGridDiv>
                        <NonGridDiv className={'searchButtonRow'}>
                            <FlexGridArea area={'disasterModeLabel'}>
                                <SearchFormText>
                                    災害時モード
                                </SearchFormText>
                            </FlexGridArea>
                            <FlexGridArea area={'disasterMode'}>
                                <PPCheckboxGroup
                                    row
                                    data={disasterModeCheckBoxData}
                                    onChangeChecked={this.onChangeDisasterModeListChecked}
                                />
                            </FlexGridArea>
                            <FlexGridArea area={'disasterPreventionLabel'}>
                                <SearchFormText>
                                    防災情報
                                </SearchFormText>
                            </FlexGridArea>
                            <FlexGridArea area={'disasterPrevention'}>
                                <PPCheckboxGroup
                                    row
                                    data={disasterPreventionCheckBoxData}
                                    onChangeChecked={this.onChangeDisasterPreventionListChecked}
                                />
                            </FlexGridArea>
                            <FlexGridArea area={'searchButton'}>
                                <SearchButton onClick={this.onClickSearchButton}>
                                    検索する
                                </SearchButton>
                            </FlexGridArea>
                        </NonGridDiv>
                    </SearchForm>
                </ListSearchFormArea>
                {isOpenSelectCondominiumDialog &&
                    <NatCondominiumSelectionComponent
                        selectCondominiumType={SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value}
                        condominiumRepo={this.props.condominiumRepo}
                        condominiumGroupRepo={this.props.condominiumGroupRepo}
                        closeSelectCondominiumDiaLog={this.closeSelectCondominiumDialog}
                        setSelectedExclusionCondominiumInfo={this.setSelectedCondominiumInfoList}
                        eventEmitter={this.props.eventEmitter}
                        selectedCondominiumGroupId={selectedCondominiumGroupId}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        asyncCallFunction={this.props.asyncCallFunction}
                        excludeCondominium={selectedCondominiumCdList}
                        useFunctionId={USE_FUNCTION_ID.DISASTER}
                        rootCondominiumGroupId={HKConstants.VMN.COG.HASEKO_HOLDINGS_CONDOMINIUM_GROUP_ID}
                    />}
            </>
        )
    }

    renderDisasterModeStatusTable(disasterModeStatusList: DisasterModeInfo[]): Nullable<ReactElement> {
        if (disasterModeStatusList.length === 0) {
            return null
        }
        const headers: SortableTableHeaderCell[] = [
            {
                id: 'condominiumCd',
                label: '物件コード',
                align: 'left',
                width: '120px',
            },
            {
                id: 'condominiumName',
                label: '物件名',
                align: 'left',
                width: '250px',
            },
            {
                id: 'condominiumGroupName',
                label: '物件グループ',
                align: 'left',
                width: '170px',
            },
            {
                id: 'prefectureCd',
                label: '都道府県',
                align: 'left',
                width: '120px',
            },
            {
                id: 'address2',
                label: '市区町村',
                align: 'left',
                width: '185px',
            },
            {
                id: 'disasterMode',
                label: '災害時モード',
                align: 'center',
                sortable: true,
                direction: this.getSortDirection('disasterMode'),
                width: '173px'
            },
            {
                id: 'latestCommentDatetime',
                label: <>災害時情報共有<br/>最新コメント日時</>,
                align: 'left',
                sortable: true,
                direction: this.getSortDirection('latestCommentDatetime'),
                width: '170px',
                noWrap: false
            },
            {
                id: 'disasterPreventionRegistrationStatus',
                label: '防災情報',
                align: 'left',
                width: '90px'
            }
        ]

        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.searchResult.total ? this.state.searchResult.total : 0,
                    rowsPerPage:
                        this.state.searchCondition.pageNum ? this.state.searchCondition.pageNum : 0,
                    page: this.state.searchCondition.page ? this.state.searchCondition.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >
                <SortableTableHeader
                    noWrap={false}
                    headers={headers}
                    onSortOrderChange={this.handleSortApplication}
                />
                <SortablePaginationTableBody>
                    {this.state.disasterModeStatusList.map(
                        disasterModeStatus => this.renderDisasterStatusRecord(disasterModeStatus),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    renderDisasterStatusRecord(disasterModeInfo: DisasterModeInfo): ReactElement {
        const commentsUrl: string = `/admin/condominiums/${disasterModeInfo.condominiumCd}/disasters/comments`;
        const preventionsUrl: string = `/admin/condominiums/${disasterModeInfo.condominiumCd}/disasters/preventions`;
        return (
            <TableRow key={disasterModeInfo.condominiumCd}>
                <TableCell align={'left'}>{disasterModeInfo.condominiumCd}</TableCell>
                <TableCell align={'left'}>{disasterModeInfo.condominiumName}</TableCell>
                <TableCell align={'left'}>{disasterModeInfo.condominiumGroupName}</TableCell>
                <TableCell align={'left'}>{getPrefectureName(disasterModeInfo.prefectureCd)}</TableCell>
                <TableCell align={'left'}>{disasterModeInfo.address2}</TableCell>
                <TableCell align={'center'}>{this.renderDisasterModeDialogLabel(disasterModeInfo)}</TableCell>
                <TableCell align={'left'}><Link href={commentsUrl}>
                    {disasterModeInfo.latestCommentDatetime ?
                        formatDateTimeForUpdateDate(disasterModeInfo.latestCommentDatetime) : '未投稿'
                    }</Link></TableCell>
                <TableCell align={'left'}><Link
                    href={preventionsUrl}>{
                    disasterModeInfo.disasterPreventionRegistrationStatus === HAVE_OR_NOT.HAVE.value ? '登録済' : '未登録'
                }</Link></TableCell>
            </TableRow>
        )
    }

    renderDisasterModeDialogLabel(disasterMode: DisasterModeInfo): ReactNode {
        const notSubject = !disasterMode.disasterStartDate && !disasterMode.prevDisasterEndDate

        const assocStatusLabel = <StatusLabel status={disasterMode.disasterMode}>
            <StatusLabelText>
                {disasterMode.disasterMode === DISASTER_MODE.ON.value
                    ? DISASTER_MODE.ON.label : DISASTER_MODE.OFF.label}
            </StatusLabelText>
            <StatusIcon disabled={notSubject}/>
        </StatusLabel>

        return <CenterRowFlexContainer>
            {notSubject
                ? assocStatusLabel
                : <HoverPopupArea
                    anchor={'top-center'}
                    content={this.renderStatusDialog(disasterMode)}
                >
                    {assocStatusLabel}
                </HoverPopupArea>}
        </CenterRowFlexContainer>

    }

    renderStatusDialog = (disasterMode: DisasterModeInfo) => {
        return <>
            <StatusDialog>
                <StatusHeaderArea>
                    {disasterMode.condominiumName}
                </StatusHeaderArea>
                {this.renderStatus(disasterMode)}
            </StatusDialog>
        </>
    }

    renderStatusItem = (title: string, content: string) => {
        return <>
            <StatusItem>
                <StatusItemTitle>{title}</StatusItemTitle>
                <StatusItemContent>{content}</StatusItemContent>
            </StatusItem>
        </>
    }

    renderStatus = (disasterMode: DisasterModeInfo) => {
        return disasterMode.disasterMode === DISASTER_MODE.ON.value ?
            <DisasterModeDetailInfoArea>
                <DisasterModeDetailInfoRow>
                    {this.renderStatusItem('設定者', disasterMode?.setterFamilyName + ' '
                        + disasterMode?.setterFirstName)}
                </DisasterModeDetailInfoRow>
                <DisasterModeDetailInfoRow>
                    {this.renderStatusItem('設定日時',
                        formatDateTimeSlashSeparator(disasterMode?.setDatetime))}
                </DisasterModeDetailInfoRow>
                <DisasterModeDetailInfoRow>
                    {this.renderStatusItem('災害時モード終了予定日',
                        formatDateSlashSeparator(disasterMode?.disasterEndDate))}
                </DisasterModeDetailInfoRow>
                <DisasterModeDetailInfoRow>
                    {this.renderStatusItem('前回災害時モード終了日',
                        disasterMode?.prevDisasterEndDate ?
                            formatDateSlashSeparator(disasterMode?.prevDisasterEndDate) : 'ー')}
                </DisasterModeDetailInfoRow>
            </DisasterModeDetailInfoArea>
            : <DisasterModeDetailInfoArea>
                <DisasterModeDetailInfoRow>
                    {this.renderStatusItem('解除者',
                        disasterMode?.setterRoleId ?
                            disasterMode?.setterFamilyName + ' ' + disasterMode?.setterFirstName : 'システムによる自動解除')}
                </DisasterModeDetailInfoRow>
                <DisasterModeDetailInfoRow>
                    {this.renderStatusItem('解除日時',
                        formatDateTimeSlashSeparator(disasterMode?.setDatetime))}
                </DisasterModeDetailInfoRow>
            </DisasterModeDetailInfoArea>
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return <>
            {this.renderDisasterModeStatusSearchInfo()}
            <SearchPageActionArea>
                <ButtonArea>
                    <ModeSettingButtonArea>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_DISASTER_MODE}>
                            <AdminDefaultMediumButton onClick={this.onClickSettingButton}>
                                災害時モードの設定
                            </AdminDefaultMediumButton>
                            <AdminDefaultMediumButton onClick={this.onClickReleaseButton}>
                                災害時モードの解除
                            </AdminDefaultMediumButton>
                        </AuthorityChecker>
                    </ModeSettingButtonArea>
                    <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.OUTPUT_DISASTER_MODE}>
                        <AdminDefaultMediumButton onClick={this.onClickDisasterModeStatusDataOutput}>
                            モード設定状況を抽出
                        </AdminDefaultMediumButton>
                    </AuthorityChecker>
                </ButtonArea>
            </SearchPageActionArea>
            <PageMainArea>
                {this.renderDisasterModeStatusTable(this.state.disasterModeStatusList)}
            </PageMainArea>
        </>
    }
}

export default createAdminPage(NatAdminDisasterModeStatusListPage)

const SearchForm = styled.div`
    display: grid;
    grid-template:
            "condominiumGroupSelectLabel condominiumGroupSelect condominiumGroupSelect condominiumGroupSelect condominiumGroupSelect ."
            "condominiumSelectLabel condominiumSelectButton selectedCondominiums selectedCondominiums selectedCondominiums ."
            "CondominiumCdLabel CondominiumCd CondominiumCd  CondominiumNameLabel CondominiumName CondominiumName"
            "prefectureCdLabel prefectureCd prefectureCd  address2Label address2 address2"
            "disasterModeLabel disasterMode disasterMode  disasterPreventionLabel disasterPrevention searchButton"
              / max-content max-content minmax(20px, 1fr) max-content minmax(210px, 1fr) max-content;
    row-gap: 16px;
    column-gap: 16px;
`
const NonGridDiv = styled.div`
    display: contents;
`
const SearchFormInputContainer = styled.div`
    width: 600px;
`
const SearchFormText = styled.div`
    padding: 0 12px;
`
const ButtonArea: StyledDiv = styled.div`
    display: flex;
    justify-content: space-between;
`
const ModeSettingButtonArea: StyledDiv = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 24px;
`
const SearchInputContainerLeft = styled.div`
    width: 100%;
    max-width: 388px;
`
const SearchInputContainerRight = styled.div`
    width: 100%;
    max-width: 388px;
`
const SearchButton = styled(AdminDefaultButton)`
    width: 204px;
`
const StatusLabel = styled.div<{ status: string }>`
    display: flex;
    align-items: center;
    width: 120px;
    height: 42px;
    border-radius: 50px;
    background-color: ${props =>
            props.status === DISASTER_MODE.ON.value ? '#F9BEC8'
                            : '#EDEDED'};
    padding: 9px 22.5px;
    gap: 8px;
    user-select: none;
`
const StatusLabelText = styled.div`
    flex-grow: 1;
`
const StatusIcon = styled(LibraryBooksOutlinedIcon)<{ disabled: boolean }>`
    color: ${props => props.disabled ? Colors.AccentLight : 'inherit'};
`
const StatusDialog = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 24px;
    width: 394px;
    gap: 16px;
    text-align: left;
`
const StatusHeaderArea = styled.div`
    font-size: ${FontSizeInPixel.Body}px;
    background-color: ${Colors.Background};
    font-weight: ${FontWeights.Bold};
    padding: 8px 11px;
`
const StatusItem = styled.div`
    display: flex;
    align-items: flex-start;
`
const StatusItemTitle = styled.div`
    display: inline-block;
    min-width: 155px;
`
const StatusItemContent = styled.div`
    display: inline-block;
    white-space: pre-wrap;
    margin-left: 12px;
`
const DisasterModeDetailInfoArea = styled.div`
    margin-left: 16px;
`
const DisasterModeDetailInfoRow = styled.div`
    margin-top: 8px;
    margin-bottom: 8px;
`